/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class InventoryVault {
  /**
  * The id of the vault
  */
  'id': string;
  /**
  * The name of the vault
  */
  'name': string;
  /**
  * The region of the vault
  */
  'region': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return InventoryVault.attributeTypeMap;
  }

  public constructor() {
  }
}

